import { setOwner } from "@ember/owner";
import { service } from "@ember/service";

/**
 * Base class representing a sidebar community section link interface.
 */
export default class BaseCommunitySectionLink {
  // TODO: All those are used by subclasses
  // eslint-disable-next-line discourse/no-unused-services
  @service currentUser;
  // eslint-disable-next-line discourse/no-unused-services
  @service appEvents;
  // eslint-disable-next-line discourse/no-unused-services
  @service router;
  // eslint-disable-next-line discourse/no-unused-services
  @service siteSettings;
  // eslint-disable-next-line discourse/no-unused-services
  @service topicTrackingState;

  constructor(owner, { inMoreDrawer, overriddenName, overriddenIcon } = {}) {
    setOwner(this, owner);
    this.inMoreDrawer = inMoreDrawer;
    this.overriddenName = overriddenName;
    this.overriddenIcon = overriddenIcon;
  }

  /**
   * @returns {string} The name of the section link. Needs to be dasherized and lowercase.
   */
  get name() {
    this._notImplemented();
  }

  /**
   * @returns {boolean} Whether the section link should be displayed. Defaults to true.
   */
  get shouldDisplay() {
    return true;
  }

  /**
   * @returns {string|undefined} Ember route
   */
  get route() {}

  /**
   * @returns {string} href attribute for the link. This property will take precedence over the `route` property when set.
   */
  get href() {}

  /**
   * @returns {string | number | object | null | undefined} Model for <LinkTo> component. See https://api.emberjs.com/ember/release/classes/Ember.Templates.components/methods/LinkTo?anchor=LinkTo
   */
  get model() {}

  /**
   * @returns {Array<string | number | object> | undefined} Models for <LinkTo> component. See https://api.emberjs.com/ember/release/classes/Ember.Templates.components/methods/LinkTo?anchor=LinkTo
   */
  get models() {}

  /**
   * @returns {Record<string, unknown>} Query parameters for <LinkTo> component. See https://api.emberjs.com/ember/release/classes/Ember.Templates.components/methods/LinkTo?anchor=LinkTo
   */
  get query() {
    return {};
  }

  /**
   * @returns {String} current-when for <LinkTo> component. See https://api.emberjs.com/ember/release/classes/Ember.Templates.components/methods/LinkTo?anchor=LinkTo
   */
  get currentWhen() {}

  /**
   * @returns {string} Title for the link
   */
  get title() {
    this._notImplemented();
  }

  /**
   * @returns {string} Text for the link
   */
  get text() {
    this._notImplemented();
  }

  /**
   * @returns {string} Text for the badge within the link
   */
  get badgeText() {}

  /**
   * @private
   */
  get prefixType() {
    return "icon";
  }

  /**
   * @returns {string} The name of the fontawesome icon to be displayed before the link. Defaults to "link".
   */
  get defaultPrefixValue() {
    return "link";
  }

  /**
   * @returns {string} The name of the fontawesome icon to be displayed before the link.
   */
  get prefixValue() {
    return this.overriddenIcon || this.defaultPrefixValue;
  }

  /**
   * Called when state has changed in the TopicTrackingState service
   */
  onTopicTrackingStateChange() {}

  /**
   * Called when community-section component is torn down.
   */
  teardown() {}

  _notImplemented() {
    throw "not implemented";
  }
}
